import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerAddressListSlice = createApi({
    reducerPath: "customerAddressList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        customerAddressList: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/address/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useCustomerAddressListQuery } = customerAddressListSlice;
